<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :title="$t('Audiences_Segment_DialogCalculateRecipients_Title')"
    :before-close="onClose"
    width="400px"
  >
    <el-form>
      <div
        style="margin-bottom: 20px; line-height: 26px"
        v-html="$t('Audiences_Segment_DialogCalculateRecipients_Info')"
      />

      <el-form-item style="margin-bottom: 8px">
        <el-select
          v-model="categoryId"
          clearable
          :placeholder="
            $t('Audiences_Segment_DialogCalculateRecipients_EngagementCategory')
          "
        >
          <el-option
            v-for="category in categories"
            :key="category.id"
            :value="category.id"
            :label="category.title"
          />
        </el-select>
      </el-form-item>

      <el-form-item style="margin-bottom: 0">
        <el-checkbox v-model="subscription">
          {{ $t('Audiences_Segment_DialogCalculateRecipients_Subscription') }}
        </el-checkbox>
      </el-form-item>

      <el-form-item style="margin-bottom: 0" description="test" hint="test2">
        <el-checkbox v-model="suppression">
          {{ $t('Audiences_Segment_DialogCalculateRecipients_Suppression') }}
        </el-checkbox>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="run" type="primary" plain>
        {{ $t('Audiences_Segment_DialogCalculateRecipients_CountBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import { projectEndpoint } from '../../../core/helpers'
import RestApi from '../../../core/services/RestApi'

export default {
  name: 'ChannelReachConfigureDialog',

  data() {
    return {
      subscription: false,
      suppression: false,
      categoryId: null,
      categories: []
    }
  },

  mounted() {
    RestApi(this.categoriesFetchEndpoint).then(({ data }) => {
      this.categories = data
    })
  },

  computed: {
    categoriesFetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'categories',
        params: {}
      })
    }
  },

  methods: {
    onClose() {
      EventBus.$emit('channels-reach-hide')
    },
    run() {
      EventBus.$emit(
        'channels-reach-show',
        {
          subscription: this.subscription,
          suppression: this.suppression,
          categoryId: this.categoryId
        },
        true
      )
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/ChannelReachConfigureDialog.vue